import { render } from "./Detail.vue?vue&type=template&id=b1a7f66e&ts=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__